import simpleLayout from '../../layouts/simple'

export default {
  path: 'user',
  component: simpleLayout,
  children: [
    {
      path: 'login',
      meta: {
        title: ''
      },
      component: () => import('./login/login.vue')
    },
    {
      path: 'sign-up-form',
      meta: {
        title: '',
        showFooter: false
      },
      component: () => import('./sign-up-form/sign-up-form.vue')
    },
    {
      path: 'register',
      meta: {
        title: '注册'
      },
      component: () => import('./register')
    }
  ]
}
